
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff","data-name":"vuesax/twotone/notification-bing"}},[_c('path',{attrs:{"d":"M12 22.9a4.105 4.105 0 01-2.88-1.2 4.105 4.105 0 01-1.2-2.88h1.5a2.6 2.6 0 00.76 1.82 2.6 2.6 0 001.82.76 2.583 2.583 0 002.58-2.58h1.5A4.085 4.085 0 0112 22.9z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M12 10.52a.75.75 0 01-.75-.75V6.44a.75.75 0 01.75-.75.75.75 0 01.75.75v3.33a.75.75 0 01-.75.75z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M12.02 1.25a7.437 7.437 0 017.42 7.408v2.1a4.546 4.546 0 00.522 1.892l1.271 2.122a2.97 2.97 0 01-1.606 4.347 24.042 24.042 0 01-7.6 1.231 24.041 24.041 0 01-7.6-1.231 2.948 2.948 0 01-1.9-1.76 3 3 0 01.29-2.585l1.27-2.119a4.469 4.469 0 00.523-1.895v-2.1a7.418 7.418 0 017.41-7.41zm0 17.6a22.544 22.544 0 007.134-1.15 1.47 1.47 0 00.793-2.153l-1.27-2.12a5.991 5.991 0 01-.737-2.665V8.66a5.915 5.915 0 00-11.83 0v2.1a5.9 5.9 0 01-.738 2.667l-1.269 2.118a1.494 1.494 0 00-.171 1.293 1.479 1.479 0 00.965.86 22.543 22.543 0 007.128 1.155z"}})])])
          )
        }
      }
    